/**
 * Table of Contents functionality
 */
 projectFunctions.tableOfContentsFunctions = projectFunctions.tableOfContentsFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
 
projectFunctions.tableOfContentsFunctions.init = function() {
    this.tableOfContents();
};

projectFunctions.tableOfContentsFunctions.tableOfContents = function () {
  if (!$('.custom-single-post__table-list').length) {
    return;
  }
  const $headings = $('.custom-single-post__content h2');
  const $toc = $('.custom-single-post__table-list');

  if ($headings.length > 0 && $toc.length) {
    $headings.each(function(index) {
      const $heading = $(this);
      const id = `heading-${index}`;
      $heading.attr('id', id);

      const $li = $('<li>');
      const $a = $('<a>').attr('href', `#${id}`).text(`${index + 1}. ${$heading.text() || 'Heading'}`);
      $li.append($a);
      $toc.append($li);
    });

    $(window).on('scroll', function() {
      let found = false;
      
      for (let i = $headings.length - 1; i >= 0; i--) {
        const heading = $headings[i];
        const headingBox = heading.getBoundingClientRect();
        
        if (headingBox.top < window.innerHeight * 0.2) {
          const id = $(heading).attr('id');
          $('.custom-single-post__table-list a').removeClass('active');
          $(`.custom-single-post__table-list a[href="#${id}"]`).addClass('active');
          found = true;
          break;
        }
      }
      
      if (!found) {
        $('.custom-single-post__table-list a').removeClass('active');
      }
    });

    // Smooth scroll on click
    $toc.on('click', 'a', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const target = $(this).attr('href');
      const $target = $(target);
      
      if ($target.length) {
        $('html, body').stop().animate({
          scrollTop: $target.offset().top - 100
        }, 400);
      }
    });
  }
};

